import AssetFormWrapper from "../../components/asset-forms/AssetFormWrapper";

/**
 * Collectibles Asset Edit View
 * Now uses the unified AssetFormWrapper component
 */
const CollectiblesView = ({ assetId, startInEditMode }) => {
  return (
    <AssetFormWrapper
      mode="edit"
      subCategory="collectibles"
      assetId={assetId}
      startInEditMode={startInEditMode}
    />
  );
};

export default CollectiblesView;
